// extracted by mini-css-extract-plugin
export default {"container":"image-credits_container__R1CIO","label":"image-credits_label__3f_zR","credits":"image-credits_credits__3Reyr"};